import { render, staticRenderFns } from "./PPDAndTPDConfirmModal.vue?vue&type=template&id=609cec46&lang=pug&"
import script from "./PPDAndTPDConfirmModal.vue?vue&type=script&lang=ts&"
export * from "./PPDAndTPDConfirmModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports